var map = {
	"./CategoriesOverview": [
		"XNJi",
		2
	],
	"./CategoriesOverview.js": [
		"XNJi",
		2
	],
	"./CategoryPatterns": [
		"Y2YK",
		12
	],
	"./CategoryPatterns.js": [
		"Y2YK",
		12
	],
	"./ColorSwatchesCartForm": [
		"iSCd",
		6
	],
	"./ColorSwatchesCartForm.js": [
		"iSCd",
		6
	],
	"./DesignerGallery": [
		"ESsZ",
		11
	],
	"./DesignerGallery.js": [
		"ESsZ",
		11
	],
	"./ExternalLink": [
		"6mzq",
		57
	],
	"./ExternalLink.js": [
		"6mzq",
		57
	],
	"./Fabrics": [
		"xAT9",
		36
	],
	"./Fabrics.js": [
		"xAT9",
		36
	],
	"./FavoritesGallery": [
		"5bKB",
		7
	],
	"./FavoritesGallery.js": [
		"5bKB",
		7
	],
	"./Hashtag": [
		"xFfy",
		21
	],
	"./Hashtag.js": [
		"xFfy",
		21
	],
	"./Header": [
		"O2nu",
		25
	],
	"./Header.js": [
		"O2nu",
		25
	],
	"./Heading": [
		"4/2G",
		56
	],
	"./Heading.js": [
		"4/2G",
		56
	],
	"./Home": [
		"FYqW",
		3
	],
	"./Home.js": [
		"FYqW",
		3
	],
	"./LinearProgress": [
		"jZGx",
		52
	],
	"./LinearProgress.js": [
		"jZGx",
		52
	],
	"./Logo": [
		"5+D9",
		55
	],
	"./Logo.js": [
		"5+D9",
		55
	],
	"./LogoQ": [
		"lJWF",
		51
	],
	"./LogoQ.js": [
		"lJWF",
		51
	],
	"./NewsletterForm": [
		"rss6",
		5
	],
	"./NewsletterForm.js": [
		"rss6",
		5
	],
	"./NewsletterSubscribed": [
		"Qe2F",
		10
	],
	"./NewsletterSubscribed.js": [
		"Qe2F",
		10
	],
	"./PatternGalleries": [
		"8L6y",
		13
	],
	"./PatternGalleries.js": [
		"8L6y",
		13
	],
	"./PatternRepeat": [
		"Dy6C",
		50
	],
	"./PatternRepeat.js": [
		"Dy6C",
		50
	],
	"./PatterngalleryNewest": [
		"LXGs",
		9
	],
	"./PatterngalleryNewest.js": [
		"LXGs",
		9
	],
	"./SearchResult": [
		"1+Ik",
		8
	],
	"./SearchResult.js": [
		"1+Ik",
		8
	],
	"./SewpatCard": [
		"Je5D",
		32
	],
	"./SewpatCard.js": [
		"Je5D",
		32
	],
	"./SewpatGalleries": [
		"szLU",
		27
	],
	"./SewpatGalleries.js": [
		"szLU",
		27
	],
	"./SewpatGallery": [
		"jTE+",
		4
	],
	"./SewpatGallery.js": [
		"jTE+",
		4
	],
	"./SinglePatternView": [
		"pwTb",
		0
	],
	"./SinglePatternView.js": [
		"pwTb",
		0
	],
	"./SingleSewpatView": [
		"mQua",
		1
	],
	"./SingleSewpatView.js": [
		"mQua",
		1
	],
	"./SubCategoryGallery": [
		"FoP/",
		34
	],
	"./SubCategoryGallery.js": [
		"FoP/",
		34
	],
	"./TopCategoriesGalleries": [
		"jiVp",
		35
	],
	"./TopCategoriesGalleries.js": [
		"jiVp",
		35
	],
	"./deAbout": [
		"eNS2",
		31
	],
	"./deAbout.js": [
		"eNS2",
		31
	],
	"./deImprint": [
		"C8X8",
		44
	],
	"./deImprint.js": [
		"C8X8",
		44
	],
	"./dePrivacy": [
		"V+fu",
		43
	],
	"./dePrivacy.js": [
		"V+fu",
		43
	],
	"./deShipping": [
		"EgZD",
		29
	],
	"./deShipping.js": [
		"EgZD",
		29
	],
	"./deTos": [
		"4NqZ",
		42
	],
	"./deTos.js": [
		"4NqZ",
		42
	],
	"./defaq-coloring-options": [
		"9N07",
		37
	],
	"./defaq-coloring-options.js": [
		"9N07",
		37
	],
	"./enAbout": [
		"6HBO",
		30
	],
	"./enAbout.js": [
		"6HBO",
		30
	],
	"./enImprint": [
		"yqnL",
		41
	],
	"./enImprint.js": [
		"yqnL",
		41
	],
	"./enPrivacy": [
		"UU+7",
		40
	],
	"./enPrivacy.js": [
		"UU+7",
		40
	],
	"./enShipping": [
		"5mFl",
		28
	],
	"./enShipping.js": [
		"5mFl",
		28
	],
	"./enTos": [
		"dtML",
		39
	],
	"./enTos.js": [
		"dtML",
		39
	],
	"./enfaq-coloring-options": [
		"Ds/6",
		38
	],
	"./enfaq-coloring-options.js": [
		"Ds/6",
		38
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "H9u5";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/components/async lazy ^\.\/.*$
// module id = H9u5
// module chunks = 58